import { TextField } from "@mui/material";



export function InputSelect( {name, label, value, values, onChange, disabled=false, error, helperText} ) {
  return (
    <TextField
      select
      disabled={disabled}
      name={name}
      label={label}
      value={value}
      onChange={onChange}
      fullWidth
      size="small"
      SelectProps={{
        native: true,
      }}
      InputLabelProps={{ shrink: true }}
      margin="dense"
      variant="outlined"
      style={{marginTop: "1px"}}
      error={error}
      helperText={helperText}
    >
      {values.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </TextField>
  );
}
